import { render } from "./SelectStone.vue?vue&type=template&id=28a0f6c3&scoped=true&lang=html"
import script from "./SelectStone.vue?vue&type=script&lang=js"
export * from "./SelectStone.vue?vue&type=script&lang=js"

import "./SelectStone.vue?vue&type=style&index=0&id=28a0f6c3&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a0f6c3"]])

export default __exports__